import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

import { JsonView, allExpanded, darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

//Actions
import { detailsLastReadingRequest, clearRedux } from 'Redux/actions';

const LastReading = (props) => {

    const { setLastReading, device } = props
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const result = useSelector((state) => state.lastReadingRedux.result);
    const [lastReadingInfo, setLastReadingInfo] = useState(null);

    useEffect(() => {
        device && dispatch(detailsLastReadingRequest({ accountId: device?.company?.id, deviceId: device?.id }))
        return () => {
            dispatch(clearRedux("DETAILS_LAST_READING"))
        }
    }, [device])

    useEffect(() => {
        if (result) {
            let data = result ? JSON.parse(result) : null;
            setLastReadingInfo(data);
            setLastReading && setLastReading(data)
        }
    }, [result])

    return (
        <div style={{ marginTop: 10, marginBottom: 10 }}>
            {lastReadingInfo ?
                <JsonView data={lastReadingInfo} shouldExpandNode={allExpanded} style={defaultStyles} />
                : <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 10, opacity: 0.5 }}>{messages['common_no_information_to_display']}</div>}
        </div>
    )
}

export default LastReading;